export class LocationModel {
  province: string;
  provinceCode: string;
  municipality: string;
  municipalityCode: string;
}

export enum LocationTypeEnum {
  None = -11,
  Municipality = 0,
  Province = 1
}
